import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'unity-button-old',
    templateUrl: './unity-button.component.html',
    styleUrls: ['./unity-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnityButtonComponent {
    public _classes = '';
    public _loading = false;
    public _dirty = false;

    @Input() id = '';
    @Input() title = '';
    @Input()
    set classes(value: string) {
        this._classes = value; // used to override default button class
    }
    @Input() disabled = false;
    @Input() type = 'button';

    @Input()
    set loading(value: boolean) {
        this._loading = value;
    }

    @Input()
    pristineClass = 'secondary'; //default class for pristine model  (if dirty input used and model is not dirty)

    @Input()
    dirtyClass = 'primary'; //default class for dirty model  (if dirty input used and model is dirty)

    @Input()
    set dirty(value: boolean) {
        this._dirty = value;
        // if (value && value == true) {
        //   this._classes = this.dirtyClass;
        // }
        // this._classes = value && value == true ? this.dirtyClass : this.pristineClass;
    }

    @Output() click = new EventEmitter();

    buttonClicked(e: Event) {
        e.stopPropagation();
        e.cancelBubble = true;
        if (this.disabled !== true) {
            this.click.emit(e);
        }
    }
}
